<h2 mat-dialog-title>Tyler Smart Meter Notification Type</h2>

<mat-dialog-content>
    <form [formGroup]="formGroup">
        <b>Notify Account Holder</b>
        <div class="checkboxPadding" fxLayout="column">
            <lgd-checkbox *ngIf="email" controlName="email" [label]="emailLabel">
            </lgd-checkbox>

            <lgd-checkbox *ngIf="sms" controlName="sms" [label]="smsLabel">
            </lgd-checkbox>

            <lgd-checkbox *ngIf="phone" controlName="phone" [label]="phoneLabel">
            </lgd-checkbox>

            <div *ngIf="noContactInformation">
                No notification will be sent. Email address and phone number were not provided.
            </div>
        </div>

        <b>Notify Landlord</b>
        <div class="checkboxPadding" fxLayout="column">
            <lgd-checkbox *ngIf="landlordEmail" controlName="landlordEmail" [label]="landlordEmailLabel">
            </lgd-checkbox>

            <lgd-checkbox *ngIf="landlordSms" controlName="landlordSms" [label]="landlordSmsLabel">
            </lgd-checkbox>

            <lgd-checkbox *ngIf="landlordPhone" controlName="landlordPhone" [label]="landlordPhoneLabel">
            </lgd-checkbox>

            <div *ngIf="noLandLordContactInformation">
                Landlord notification settings not found.
            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
    <button mat-button color="primary" (click)="sendNotification()">Send Notification</button>

    <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
</mat-dialog-actions>